module.exports = __webpack_public_path__ + "img/gear.981a06a3.svg";